module EditableLabel {
    class LabelData {
        id: number;
        html: string;

        constructor(id: number, html: string) {
            this.id = id;
            this.html = html;
        }
    }

    let editableLabelHTML = `
<div id='edit#' style='display: none' class= 'input-group ccc editableLabelEdit'>
	<input id='editTextBox#' type='textbox' class='form-control elementHeight' onkeypress="if (event.which == 13) EditableLabel.Save(#)" onblur="EditableLabel.Save(#)"/>
	<span class="input-group-addon clickableIcon elementHeight" onclick="EditableLabel.Save(#)">
	    <span class="glyphicon glyphicon-ok""></span>
	</span>
</div>
<div id='text#' class="clickableIcon editableLabelText" onclick="EditableLabel.Edit(#)">
	<span class="lbl" id='label#'>*text*</span>
    <div class='glyphicon glyphicon-pencil'></div>
</div>`;
    let idCounter: number = 1;
    let saveFunctions: { [key: number]: (newValue: string, id: number) => void } = {};

    export function Create(text: string, onSave: (newValue: string, id: number) => void): LabelData {
        idCounter++;
        saveFunctions[idCounter] = onSave;
        let html = editableLabelHTML.replace(new RegExp("#", 'g'), idCounter.toString()).replace("*text*", text);
        return new LabelData(idCounter, html);
    }

    export function Save(id: number) {
        $("#label" + id).html($("#editTextBox" + id).val());
        saveFunctions[id]($("#editTextBox" + id).val(), id);
    }
    export function Close(id: number) {
        $("#edit" + id).hide();
        $("#text" + id).show();
    }
    export function Edit(id: number) {
        $("#editTextBox" + id).val($("#label" + id).html());
        $("#edit" + id).show();
        $("#text" + id).hide();
    }

    export function SetText(id: number, text: string) {
        $("#editTextBox" + id).val(text);
        $("#label" + id).html(text);
    }
}